// extracted by mini-css-extract-plugin
export default {"description":"qzC67","icon":"uU987","text":"kUEvP"};